import { app } from '../../../app';
import { Controller } from './computer-protection.controller';

app.component('companyComputerProtection', {
    bindings: {
        applications: '<',
        appType$: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./computer-protection.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/computer-protection/computer-protection.component.js